module.exports = __webpack_public_path__ + "img/CloseCombat.90343d90.png";